module.exports = __webpack_public_path__ + "static/media/outline-format_indent_increase-24px.bc17da31.svg";